import { useState, useEffect, useRef } from 'react';

// Automatic tooltip when detecting text overflow
const TooltipCell = ({ value }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
        const checkOverflow = () => {
            if (textRef.current) {
                const isOverflowing = textRef.current.scrollWidth > textRef.current.clientWidth;
                setShowTooltip(isOverflowing);
            }
        };

        // Check overflow after render
        const timeoutId = setTimeout(checkOverflow, 100);
        
        // Check on window resize
        window.addEventListener('resize', checkOverflow);
        
        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener('resize', checkOverflow);
        };
    }, [value]);

    if (value === null) return <span>--</span>;

    return (
        <span 
            ref={textRef}
            title={showTooltip ? value : undefined}
            style={{ 
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            }}
        >
            {value}
        </span>
    );
};

export default TooltipCell;